<template>
    <span class="font-weight-bold">{{ node && node.key }}</span>
</template>

<script>
    export default {
        data() {
            return {
                node: null,
            }
        },
        created() {
            this.node = this.params.node;
        }
    }
</script>